import {drawTransparentPoint} from "./strokePainter";

export function fillHoles(ctx, imageData) {
    const thresholdSize = 6000; // Define threshold size for filling
    let visited = new Array(imageData.width * imageData.height).fill(false);

    function isTransparent(x, y) {
        const index = (y * imageData.width + x) * 4;
        return imageData.data[index + 3] < 254;
    }

    function fillIsland(pixels) {
        pixels.forEach(({x, y}) => {
            drawTransparentPoint(ctx, x, y, 2);
        });
    }

    function getIslandSizeAndPixels(x, y) {
        let stack = [{x, y}];
        let pixels = [];
        let size = 0;

        while (stack.length > 0) {
            let { x, y } = stack.pop();
            const index = y * imageData.width + x;

            if (x < 0 || x >= imageData.width || y < 0 || y >= imageData.height || visited[index] || !isTransparent(x, y)) {
                continue;
            }

            visited[index] = true;
            size++;
            pixels.push({x, y});

            stack.push({x: x + 1, y: y});
            stack.push({x: x - 1, y: y});
            stack.push({x: x, y: y + 1});
            stack.push({x: x, y: y - 1});
        }

        return { size, pixels };
    }

    for (let y = 0; y < imageData.height; y++) {
        for (let x = 0; x < imageData.width; x++) {
            if (isTransparent(x, y) && !visited[y * imageData.width + x]) {
                const { size, pixels } = getIslandSizeAndPixels(x, y);

                // let zoom = window.imageEditor.store.canvas.getZoom();

                if (size <= thresholdSize) {
                    fillIsland(pixels);
                }
            }
        }
    }
}
